import { render } from "./NcrmLeadDetails.vue?vue&type=template&id=6d57e854&scoped=true"
import script from "./NcrmLeadDetails.vue?vue&type=script&lang=js"
export * from "./NcrmLeadDetails.vue?vue&type=script&lang=js"

import "./NcrmLeadDetails.vue?vue&type=style&index=0&id=6d57e854&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d57e854"]])

export default __exports__